<script setup lang="ts">
import { IconInfo } from '@/components/icons'
import { useStore } from '@/stores/store'
import { storeToRefs } from 'pinia'

const store = useStore()
const { topStitchesType, isStitches } = storeToRefs(store)
const topStitchesSingle = `${store.imgPath}/shapes/top-stitches-single.jpg`
const topStitchesDouble = `${store.imgPath}/shapes/top-stitches-double.jpg`
</script>
<template>
  <transition name="modal">
    <div class="modal-mask" v-if="isStitches === 'stitches_yes'">
      <div class="fabrics-list-wrapper space-y-6 lg:space-y-10">
        <div
          class="flex flex-col items-start bg-black/80 px-6 py-4 text-white w-full max-w-[480px] space-y-4"
        >
          <div class="flex gap-2">
            <IconInfo /><span>{{ $t('Stitch on top follow the buttons') }}</span>
          </div>
        </div>
        <fieldset class="form-padding space-y-2">
          <legend class="font-semibold text-lg lg:text-xl">
            {{ $t('Please choose type of top sewing') }}
          </legend>
          <div class="form-part stitches-part flex gap-4">
            <label class="shape-item" for="top_stitches_single">
              <div class="distribution-sample">
                <img :src="topStitchesSingle" />
              </div>
              <div class="shape-wrapper">
                <input
                  id="top_stitches_single"
                  v-model="topStitchesType"
                  required
                  type="radio"
                  class="radio-input"
                  value="top_stitches_single"
                  name="topStitchesType"
                />
                <span class="check-text">{{ $t('Single') }}</span>
              </div>
            </label>
            <label class="shape-item" for="top_stitches_double">
              <div class="distribution-sample">
                <img :src="topStitchesDouble" />
              </div>
              <div class="shape-wrapper">
                <input
                  id="top_stitches_double"
                  v-model="topStitchesType"
                  required
                  type="radio"
                  class="radio-input"
                  value="top_stitches_double"
                  name="topStitchesType"
                />

                <span class="check-text">{{ $t('Double') }}</span>
              </div>
            </label>
          </div>
        </fieldset>
      </div>
    </div>
  </transition>
</template>

<style scoped></style>
